import { ShoppingCartFormat } from "../../../models";

export const TAB_PARAM = "tab";
export const TAB_INVOICES = "racuni";
export const TAB_PURCHASES = "potrosnja";

export const TAB_TO_FORMAT = {
  [TAB_INVOICES]: ShoppingCartFormat.invoices,
  [TAB_PURCHASES]: ShoppingCartFormat.purchases,
};



// WEBPACK FOOTER //
// ./src/containers/FinancePage/constants/constants.ts